import { JupyterDockerEnvironment, MachineConfiguration, oldJupyterEnv } from 'polly-commons';
import { NotebookIncludedAttributesInterface, NotebookConfigLabelsInterface, CreateNotebookInterface, SageMakerNotebookPayload, NotebookConfig, StringFormAttribute } from '../../../polly-manage.interfaces';

/**
 * This function finds the respective labels for docker and machine
 * of a notebook
 */
export function getNotebookLabels(
  notebookDetails: NotebookIncludedAttributesInterface,
  dockerEnvironments: JupyterDockerEnvironment[],
  machineConfigurations: MachineConfiguration[]
): NotebookConfigLabelsInterface {
  const labelsNotebookConfig: NotebookConfigLabelsInterface = { docker: '', machine: '' };
  for (const env of oldJupyterEnv) {
    if (env.oldEnv === notebookDetails.attributes.notebook_config.kernel) {
      notebookDetails.attributes.notebook_config.kernel = env.newEnv;
    }
  }
  for (const docker of dockerEnvironments) {
    if (docker.value === notebookDetails.attributes.notebook_config.kernel) {
      labelsNotebookConfig.docker = docker.displayText + ':' + docker.verbose;
      break;
    }
  }
  for (const machine of machineConfigurations) {
    for (const conf of machine.configuration) {
      if (conf.value === notebookDetails.attributes.notebook_config.machine) {
        labelsNotebookConfig.machine = conf.displayText + ':' + conf.verbose;
        return labelsNotebookConfig;
      }
    }
  }
  return labelsNotebookConfig;
}

/**
 * @description Returns the path where notebook is stored, used to launch the notebooks from correct path
 *
 * @param currentPath string path fetched from currentFolderPath$ subject
 * @return string: formatted path
 */
export function getNotebookPath(currentPath: string): string {
  currentPath = currentPath.replace(/projects\/\d+\/files/, '');
  return currentPath;
}

/**
 * @description Removes deprecated docker environments from available docker env array
 * - Uses 'deprecated' property present in object, to filter it out.
 *
 * @param dockerEnvironments array of dokcer environments populated on landing page
 * @return JupyterDockerEnvironment[]
 */
export function removeDeprecatedDockerEnvs(dockerEnvironments: JupyterDockerEnvironment[]): JupyterDockerEnvironment[] {
  return dockerEnvironments.filter((env: JupyterDockerEnvironment) => !env.deprecated);
}

export function createNotebookPayload(details: CreateNotebookInterface): SageMakerNotebookPayload {
  return {
    data: {
      type: 'compute-notebook',
      attributes: {
        notebook_name: details.notebook_name,
        client_org_id: details.client_org_id,
        create_notebook: details.create_notebook,
        machine_type: details.machine_type,
        kernel: details.kernel,
        path: details.path,
        source: details.source,
        query_params: details.query_params,
      }
    }
  }
}

export function getCreateSagemakerNotebookPayload(
  notebook_name: string,
  notebook_config: NotebookConfig,
  selectedWorkspaceId: string,
  createNotebook: boolean,
  client?: StringFormAttribute,
  path?: string,
  source?: string,
): CreateNotebookInterface {
  const sagemakerNotebookDetails: CreateNotebookInterface = {
    path: path || '/',
    create_notebook: createNotebook,
    notebook_name: notebook_name.replace('.ipynb', ''),
    machine_type: notebook_config.machine || '',
    kernel: notebook_config.kernel || '',
    workspace_id: selectedWorkspaceId
  };
  if (client) {
    sagemakerNotebookDetails.client_org_id = client.value ?? undefined;
    sagemakerNotebookDetails.client_org_name = client.label ?? undefined;
  }
  if (source) {
    sagemakerNotebookDetails.source = source;
  }
  if (notebook_config.query_params) {
    sagemakerNotebookDetails.query_params = notebook_config.query_params;
  }
  return sagemakerNotebookDetails;
};
